import React, { useState } from 'react';
import { Copy, Check, MessageCircle } from 'lucide-react';

/*
 * 2026-06-26 — Admin-only copy-to-clipboard helper for Stephen.
 * Gives a one-click button to grab the canonical "Hi, this is Stephen…"
 * review-request message for manual WhatsApp / email sharing.
 *
 * No API calls. No DB writes. Read-only string. Self-contained state.
 */

export const REVIEW_SHARE_MESSAGE = `Hi, this is Stephen from Taxi-98. I hope you made it home safely and enjoyed your time in The Bahamas. If Taxi-98 made your trip easier, I would really appreciate a quick review. Reviews help future visitors book with confidence.

Google Review:
https://g.page/r/CRsSkN508n5DECA/review

TripAdvisor:
https://www.tripadvisor.com/Attraction_Review-g147416-d34296506-Reviews-Taxi_98-Nassau_New_Providence_Island_Bahamas.html

Facebook:
https://www.facebook.com/share/1FwnCAwDLX/

Website:
https://www.taxi-98.com

Thank you again for choosing Taxi-98.`;

const CopyReviewMessageButton = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(REVIEW_SHARE_MESSAGE);
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch (err) {
      // Fallback for older browsers / blocked clipboard API
      const ta = document.createElement('textarea');
      ta.value = REVIEW_SHARE_MESSAGE;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        setCopied(true);
        setTimeout(() => setCopied(false), 2200);
      } catch (e) {
        // surface a minimal hint without breaking the dashboard
        alert('Unable to copy automatically. Please copy manually.');
      }
      document.body.removeChild(ta);
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      data-testid="admin-copy-review-message-btn"
      title="Copy a ready-to-send WhatsApp/email review-request message"
      aria-label="Copy review request message to clipboard"
      className={`px-3 py-1.5 text-xs rounded transition flex items-center gap-1.5 ${
        copied
          ? 'bg-emerald-100 text-emerald-700 border border-emerald-300'
          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
      }`}
    >
      {copied ? (
        <>
          <Check className="w-3.5 h-3.5" />
          <span>Copied — paste into WhatsApp/Email</span>
        </>
      ) : (
        <>
          <MessageCircle className="w-3.5 h-3.5" />
          <span>Copy Review Request Message</span>
          <Copy className="w-3.5 h-3.5 opacity-70" />
        </>
      )}
    </button>
  );
};

export default CopyReviewMessageButton;
